import styled, { createGlobalStyle } from 'styled-components'
import * as pickers from '@material-ui/pickers'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/v2/layout'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'
import typography from '../../tokens/typography'

export const CalendarStyle = createGlobalStyle`
.MuiPaper-root.MuiPopover-paper {
  border-radius: ${defaultTheme.theme.datePicker.calendarBorderRadius};
  border: 0.2rem solid ${defaultTheme.theme.datePicker.calendarBorderColor};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);

  .MuiPickersCalendarHeader-transitionContainer {
    p {
      font-size: ${defaultTheme.theme.datePicker.calendarHeaderFontSize};
      font-weight: ${defaultTheme.theme.datePicker.calendarHeaderFontWeight};
    }

    .MuiPickersCalendar-week {
      .presentation {
        button {
          font-size: ${defaultTheme.theme.datePicker.calendarWeekFontSize};
        }
      }
    }
  }

  .MuiPickersCalendarHeader-iconButton {
    .MuiIconButton-label {
      .MuiSvgIcon-root {
        height: 24px !important;
        width: 24px !important;
      }
    }
  }

  .MuiPickersCalendarHeader-daysHeader {
    .MuiPickersCalendarHeader-dayLabel.MuiTypography-caption {
      font-size: ${defaultTheme.theme.datePicker.calendarHeaderDayFontSize};
    }
  }

  .MuiPickersSlideTransition-transitionContainer.MuiPickersCalendar-transitionContainer {
    .MuiPickersCalendar-week {
      .MuiIconButton-root.MuiPickersDay-day {
        height: 40px;
        width: 40px;
        margin: 0px;

        &.MuiPickersDay-daySelected {
          background-color: ${defaultTheme.theme.datePicker.calendarSelectedDayBackgroundColor};

          .MuiTypography-body2 {
            color: ${defaultTheme.theme.datePicker.calendarSelectedDayColor};
            font-weight: ${defaultTheme.theme.datePicker.calendarSelectedDayFontWeight};
          }

          &.MuiPickersDay-current {
            .MuiTypography-body2 {
              color: ${defaultTheme.theme.datePicker.calendarSelectedDayColor};
            }
          }
        }

        &.MuiPickersDay-current {
          .MuiTypography-body2 {
            color: ${defaultTheme.theme.datePicker.calendarCurrentDayColor};
          }
        }

        .MuiTypography-body2 {
          font-size: ${defaultTheme.theme.datePicker.calendarDayFontSize} !important;
        }
      }
    }
  }
}
`

export const DatePicker = styled(pickers.KeyboardDatePicker).attrs((props) =>
  composeTheme(props),
)`
  width: 100%;
  margin: 0;
  margin-bottom: 0.8rem;
  margin-top: 0;

  .MuiInputBase-root {
    background-color: ${colors.neutralColorHighLight};
    display: flex;
    font-family: ${fonts.inter};
    font-size: 1.4rem;
    line-height: 2.1rem;
    height: 4rem;

    .MuiInputBase-input {
      &::placeholder {
        color: ${(props) => props.theme.datePicker.placeholderColor} !important;
      }
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: ${(props) => props.theme.datePicker.borderRadius};
    border: 0.2rem solid ${colors.feedbackColorNegativePure};
  }

  .MuiOutlinedInput-input {
    padding: 1.8rem 0 1.8rem 1.6rem;
  }

  .MuiIconButton-root {
    padding: 0.4rem;
  }

  .MuiFormControl-marginNormal {
    margin: 0;
  }

  &.active {
    .MuiInputBase-root {
      background-color: ${colors.neutralColorHighPure};
      color: ${colors.neutralColorLowPure};
      font-family: ${fonts.inter};
      font-size: 1.4rem;
      line-height: 1.6rem;

      .MuiOutlinedInput-notchedOutline {
        border-radius: ${(props) => props.theme.datePicker.borderRadius};
        border: ${(props) => props.theme.datePicker.border};
      }
      .MuiSvgIcon-root {
        color: ${colors.neutralColorLowMedium};
      }
      &.Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${(props) => props.theme.brandColors.primaryPure};
        }
        .MuiSvgIcon-root {
          color: ${(props) => props.theme.brandColors.primaryPure};
        }
      }
    }
  }

  &.negative {
    .MuiInputBase-root {
      background-color: ${colors.feedbackColorNegativeLight};
      color: ${colors.feedbackColorNegativePure};
      font-family: ${fonts.inter};
      font-size: 1.4rem;
      line-height: 2.1rem;

      .MuiOutlinedInput-notchedOutline {
        border-radius: ${(props) => props.theme.datePicker.borderRadius};
        border: 0.2rem solid ${colors.feedbackColorNegativePure};
      }
      .MuiOutlinedInput-input {
        font-weight: 400;
        padding: 1.8rem 0 1.8rem 1.6rem;
      }
      .MuiIconButton-root {
        padding: 0.4rem;
      }
      .MuiSvgIcon-root {
        color: ${colors.feedbackColorNegativePure};
      }
    }
    .MuiFormHelperText-root {
      margin: ${layout.spacing.xmc} ${layout.spacing.none}
        ${layout.spacing.none} ${layout.spacing.none};
      font-size: ${typography.fontSize.fontSizeXxs};
      color: ${colors.feedbackColorNegativePure};
      font-weight: ${typography.fontWeight.fontWeightRegular};
      line-height: 21px;
    }
  }

  .Mui-disabled {
    &.MuiInputBase-root {
      background: ${colors.neutralColorHighLight};
      color: ${colors.neutralColorLowMedium};
    }
  }
`

export const Hint = styled.p.attrs((props) => composeTheme(props))`
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: ${(props) => props.theme.hint.fontWeight};
  font-size: ${(props) => props.theme.hint.fontSize};
  color: ${(props) => props.theme.hint.color};
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;

  &.is-negative {
    color: ${colors.feedbackColorNegativePure};
  }
`

DatePicker.defaultProps = defaultTheme
